<div *ngIf="html"><!--  [innerHTML]="html" class="document-preview-paper" [class.document-preview-margin]="!isNoMargin" -->
    <form class="m-0 p-0" [formGroup]="formFake" class="d-block">
        <input-editor #editor disabled [value]="html" [hasToolbar]="false" [mention]="editorService.usuariosMention"></input-editor>
    </form>
</div>
<div *ngIf="!html && emptyDocumentMensage" class="document-preview-paper" [class.document-preview-margin]="!isNoMargin">
    <div class="document-preview-no-document d-block">
        <i class="bi bi-question-octagon" style="font-size: 2rem;"></i><br>
        <h5>{{emptyDocumentMensage}}</h5>
    </div>
</div>
